const $ = jQuery

export default function ProductCounters () {
  const productViewCounters = document.querySelectorAll('.product-card__view-count')
  const productViewCountersArray = Array.from(productViewCounters)


  if (productViewCountersArray.length > 0) {
    for (let i = 0; i < productViewCountersArray.length; i++) {
      let randomNumber = Math.floor(Math.random() * 10) + 1;
      const productViewCounterSpan = productViewCountersArray[i].getElementsByTagName('SPAN')

      if(randomNumber === 1) {
        $(productViewCounterSpan).append(randomNumber + ' ' + productViewCountersArray[i].dataset.singleView)
      } else {
        $(productViewCounterSpan).append(randomNumber + ' ' + productViewCountersArray[i].dataset.multipleView)
      }
    }
  }
}
